import { NgModule } from '@angular/core';
import { ListMissionTypeComponent } from './list-mission-type/list-mission-type.component';
import { AddMissionTypeModalComponent } from './modal/add-mission-type-modal/add-mission-type-modal.component';
import { EditMissionTypeModalComponent } from './modal/edit-mission-type-modal/edit-mission-type-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { FilterMissionTypeByTypePipe } from 'src/app/shared/pipes/filterMissionTypeByType/filter-mission-type-by-type.pipe';

@NgModule({
	declarations: [
		ListMissionTypeComponent,
		AddMissionTypeModalComponent,
		EditMissionTypeModalComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: [FilterMissionTypeByTypePipe]
})
export class MissionTypeModule {}
